import React from 'react'

function index() {
  return (
    <div>DashBoard</div>
  )
}

export default index